import React, { useMemo } from 'react';
import { Neutral, Negative, Positive, Value, Icon, Unstyled } from './Trend.styles';
import { formatPercentage } from '../utils';
import LongContentPopover from '../LongContentPopover/LongContentPopover';
import { IconType } from '../Icons/HudIcons';
import HoverPopover from '../HoverPopover/HoverPopover';

export const TREND_VARIANTS = {
  unstyled: Unstyled,
  neutral: Neutral,
  positive: Positive,
  negative: Negative,
};

export type TrendSymbols = '↑' | '↓' | '↗' | '↘' | '↑🔥';
export type TrendVariants = keyof typeof TREND_VARIANTS;

export interface TrendProps {
  value: number;
  symbol?: TrendSymbols;
  variant?: TrendVariants;
  tooltip?: string;
}

const MAP_SYMBOL_TO_ICON: Record<string, IconType> = {
  '↗': 'trends.arrowUp',
  '↘': 'trends.arrowDown',
};

export default function Trend({
  value,
  symbol,
  variant = 'neutral',
  tooltip,
}: TrendProps) {
  const Variant = TREND_VARIANTS[variant];

  const icon = useMemo(() => {
    if (symbol && symbol in MAP_SYMBOL_TO_ICON) {
      return <Icon icon={MAP_SYMBOL_TO_ICON[symbol]} />;
    }
    return <Value>{symbol}</Value>;
  }, [symbol]);

  if (tooltip) {
    return (
      <HoverPopover body={tooltip} position="top" width={220}>
        <Variant>
          <Value>{formatPercentage(value)}</Value> {icon}
        </Variant>
      </HoverPopover>
    );
  }

  return (
    <LongContentPopover>
      <Variant>
        <Value>{formatPercentage(value)}</Value> {icon}
      </Variant>
    </LongContentPopover>
  );
}
